import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import AdminLogin from "./pages/AdminLogin";
// import AdminSetup from "./pages/AdminSetup";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import Stores from "./pages/Stores";
import Users from "./pages/Users";
import Suppliers from "./pages/Suppliers";
import SupplierItems from "./pages/SupplierItems";
import SupplierReturns from "./pages/SupplierReturns";
import Customers from "./pages/Customers";
import Products from "./pages/Products";
import POS from "./pages/POS";
import PrintInvoice from "./pages/PrintInvoice";
import Orders from "./pages/Orders";
import StockManagement from "./pages/StockManagement";
import CustomerHistory from "./pages/CustomerHistory";




function App() {
  return (
    <Router>
      <Routes>

        <Route path="/" element={
          
            <AdminLogin />
       
        }
        />

        {/* <Route path="/setup" element={<AdminSetup />} /> */}

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/stores"
          element={
            <ProtectedRoute>
              <Stores />
            </ProtectedRoute>
          }
        />

        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <Users />
            </ProtectedRoute>
          }
        />

        <Route
          path="/suppliers"
          element={
            <ProtectedRoute>
              <Suppliers />
            </ProtectedRoute>
          }
        />

        <Route
          path="/supplier-items/:id"
          element={
            <ProtectedRoute>
              <SupplierItems />
            </ProtectedRoute>
          }
        />

        <Route
          path="/supplier-returns"
          element={
            <ProtectedRoute>
              <SupplierReturns />
            </ProtectedRoute>
          }
        />

        <Route path="/customers" element={
          <ProtectedRoute>
            <Customers />
          </ProtectedRoute>
        } />

        <Route
          path="/customer-history/:id"
          element={
            <ProtectedRoute>
              <CustomerHistory />
            </ProtectedRoute>
          }
        />


        <Route path="/products" element={<ProtectedRoute><Products /></ProtectedRoute>} />

        <Route
          path="/pos"
          element={
            <ProtectedRoute>
              <POS />
            </ProtectedRoute>
          }
        />

        <Route path="/print-invoice/:id" element={
          <ProtectedRoute>
            <PrintInvoice />
          </ProtectedRoute>
        }
        />

        <Route path="/orders" element={
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        }
        />

        <Route path="/stock" element={
          <ProtectedRoute>
            <StockManagement />
          </ProtectedRoute>
        }
        />

      </Routes>
    </Router>
  );
}

export default App;
